// reactstrap components
import { Container } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <div className="copyright text-center text-muted">
          © {new Date().getFullYear()} AKH Dashboard
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
